export default __webpack_public_path__ + "static/media/pousada_6.85589bc8.jpg";